import React from "react";
import LoadingSpinner from "../LoadingSpinner";
import Logo from "../Logo";
import useStyles from "./styles";

const Splash = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.center}>
        <div className={classes.centerContent}>
          <Logo />
        </div>
        <LoadingSpinner />
      </div>
    </div>
  );
};

export default React.memo(Splash);
